import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronRight, Save, X, Eye, Copy } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface WizardHeaderProps {
  currentStep: number;
  totalSteps: number;
  onSaveDraft?: () => void;
  onPreview?: () => void;
  isSaving?: boolean;
}

export function WizardHeader({ 
  currentStep, 
  totalSteps, 
  onSaveDraft,
  onPreview,
  isSaving 
}: WizardHeaderProps) {
  useLanguage();
  const navigate = useNavigate();

  return (
    <div className="sticky top-0 z-20 bg-background border-b shadow-sm">
      <div className="container mx-auto px-6 py-4">
        {/* Breadcrumb */}
        <div className="flex items-center gap-2 text-sm text-muted-foreground mb-2">
          <button 
            onClick={() => navigate('/webinarios')}
            className="hover:text-foreground transition-colors"
          >
            {translateInterfaceText("Webinários")}</button>
          <ChevronRight className="h-4 w-4" />
          <span className="text-foreground font-medium">{translateInterfaceText("Criar")}</span>
        </div>

        {/* Title and Actions */}
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-2xl font-bold text-foreground">{translateInterfaceText("Criar Webinário")}</h1>
            <p className="text-sm text-muted-foreground mt-1">
              {translateInterfaceText("Etapa")}{" "}{currentStep} {" "}{translateInterfaceText("de")}{" "}{totalSteps}
            </p>
          </div>

          <div className="flex items-center gap-2">
            {onPreview && (
              <Button
                variant="outline"
                size="sm"
                onClick={onPreview}
              >
                <Eye className="h-4 w-4 mr-2" />
                {translateInterfaceText("Pré-visualizar sala")}</Button>
            )}
            
            {onSaveDraft && (
              <Button
                variant="ghost"
                size="sm"
                onClick={onSaveDraft}
                disabled={isSaving}
              >
                <Save className="h-4 w-4 mr-2" />
                {isSaving ? translateInterfaceText("Salvando...") : translateInterfaceText("Salvar rascunho")}
              </Button>
            )}

            <Button
              variant="outline"
              size="sm"
              onClick={() => navigate('/webinarios')}
            >
              <X className="h-4 w-4 mr-2" />
              {translateInterfaceText("Sair")}</Button>
          </div>
        </div>
      </div>
    </div>
  );
}
